import request from '@/utils/request'

const CryptoJS = require('crypto-js')
const key = CryptoJS.enc.Utf8.parse('lemon20220727std')
const iv = CryptoJS.enc.Utf8.parse('franke2022727std')

function webUrl () {
  return 'https://parts.franke.cn'
  // return 'http://emall.franke.cn'
}

function PassEncrypt (word) {
  var encrypted = CryptoJS.AES.encrypt(word, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})
  return encrypted.toString()
}

// 解密方法
function Decrypt (word) {
  if (!word) return
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

// 加密方法
function Encrypt (word) {
  if (!word) return
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.ciphertext.toString().toUpperCase()
}

export {
  PassEncrypt,
  Decrypt,
  Encrypt,
  webUrl
}

// localStorage  sessionStorage
export function getUserId () {
  var token = localStorage.getItem('store_info')
  if (token) {
    var jsarr = JSON.parse(token)
    return jsarr.account
  } else {
    return ''
  }
}

export function getCompanyNo () {
  var token = localStorage.getItem('store_info')
  if (token) {
    var jsarr = JSON.parse(token)
    if (jsarr.company_no) {
      return jsarr.company_no
    } else {
      return 'MCD-CHN'
    }
  } else {
    return 'MCD-CHN'
  }
}

// 封装ajax
export function ajax (params, callback) {
  var token = localStorage.getItem('store_info')
  if (token) {
    var jsarr = JSON.parse(token)
    request({
      url: '/store/api/refresh_token',
      method: 'post',
      headers: {
        'Lemon-AppId': 'lemondata_franke',
        'Lemon-AppKey': 'lemon@lemondata.top',
        'Lemon-Token': jsarr.token
      },
      data: {
        uid: jsarr.account,
        token: jsarr.token
      }
    }).then(ret => {
      if (ret && ret.code === 'success') {
        // localStorage
        localStorage.setItem('store_info', JSON.stringify({
          'token': ret.data.token,
          'account': jsarr.account,
          'company_no': jsarr.company_no,
          'login_type': jsarr.login_type
        }))
        // console.log({
        //   'Lemon-AppId': 'lemondata_franke',
        //   'Lemon-AppKey': 'lemon@lemondata.top',
        //   'Lemon-Token': ret.data.token
        // })
        request({
          url: params.url,
          method: params.method,
          headers: {
            'Lemon-AppId': 'lemondata_franke',
            'Lemon-AppKey': 'lemon@lemondata.top',
            'Lemon-Token': ret.data.token
          },
          dataType: params.dataType ? params.dataType : 'json',
          data: params.data
        }).then(rrr => {
          callback(rrr)
        })
      } else {
        console.log(ret.msg)
        if (ret.msg === '300') {
          localStorage.clear('store_info')
          setTimeout(function () {
            location.reload()
          }, 1500)
        }
      }
    })
  }
}

// 封装ajax upload
export function upload (params, callback) {
  var token = localStorage.getItem('store_info')
  if (token) {
    var jsarr = JSON.parse(token)

    request({
      url: '/store/api/refresh_token',
      method: 'post',
      headers: {
        'Lemon-AppId': 'lemondata_franke',
        'Lemon-AppKey': 'lemon@lemondata.top',
        'Lemon-Token': jsarr.token
      },
      data: {
        uid: jsarr.account,
        token: jsarr.token
      }
    }).then(ret => {
      if (ret && ret.code === 'success') {
        localStorage.setItem('store_info', JSON.stringify({
          'token': ret.data.token,
          'account': jsarr.account,
          'company_no': jsarr.company_no,
          'login_type': jsarr.login_type
        }))
        request({
          url: params.url,
          method: params.method,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Lemon-AppId': 'lemondata_franke',
            'Lemon-AppKey': 'lemon@lemondata.top',
            'Lemon-Token': ret.data.token
          },
          data: params.data
        }).then(rrr => {
          callback(rrr)
        })
      } else {
        console.log(ret.msg)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/extend.js